import './App.css';
import { useEffect, useRef } from "react";

function App() {
  const videoRef = useRef(null);
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
      videoRef.current.play().catch(() => { });
    }
  }, []);

  return (
    <div className='background'>
      <div id='logo_pini_container'>
        <img src='./Image/Pini.png' alt='Logo PINI' className='logo_pini'></img>
      </div>
      <div className='pellicule_haut_containeur'>
        <img src='./Image/Pellicule_Fixe_Haut_Gris.png' alt='Pellicule grise haut' className='pellicule_haut' />
      </div>
      <div className='pellicule_bande_containeur'>
        <img src='./Image/Pellicule_Fixe_Bande_Demo_Gris_Blanc.png' alt='Pellicule fixe grise' className='pellicule_bande' />
        <a href='https://youtu.be/4qTfROHMYxY' target='_blank' rel='noopener noreferrer'>
          <div id='clic_container'></div>
        </a>
      </div>
      <div id='presentation'>
        <p>Bonjour et bienvenue sur ma page web.</p>
        <p>Je m’appelle Pierre-Nicolas Michelozzi… un peu long, je vous l’accorde, c’est pourquoi tout le monde m’appelle Pini.</p>
        <p>Je suis actuellement étudiant à l’école Méliès, où je me forme au métier d’artisan de l’image animée, avec une spécialisation en animation 3D de personnages.</p>
        <p>Au cours de mon parcours, j’ai également développé des compétences en modélisation et en rigging, afin de pouvoir animer mes propres créations et mieux comprendre le fonctionnement des personnages.</p>
        <p>En parallèle, je m’investis beaucoup pour mon village, j’y ai créé ma marque pour mettre en valeur les villes et villages corses et pour laquelle je suis le créateur des différents designs… son nom, Made in Paese.</p>
        <p>Mais je suis aussi bénévole dans ce dernier. En effet, je m’occupe depuis déjà plus de 3 ans des affiches et j’aide lors des événements estivaux au village de Ghisoni</p>
        <p>Vous trouverez sur cette page ma dernière bande démo ainsi que plusieurs animations illustrant mes compétences actuelles.</p>
        <p>N’hésitez pas à consulter mes différents réseaux si mon travail vous intéresse.</p>
      </div>
      <div id='mp4_container'>
        <video ref={videoRef} controls={false} autoPlay loop muted playsInline disablePictureInPicture disableRemotePlayback preload="auto" className='film-video'>
          <source src='./Image/Pellicule_Animation_V003_Test_Telephone_v05.mp4' type='video/mp4' />
        </video>
      </div>
      <a href='https://youtu.be/4qTfROHMYxY' target='_blank' rel='noopener noreferrer'>
        <div id='clic_container_mobile'></div>
      </a>
      <div className='pellicule_contact_container'>
        <div className='competence'>
          <h2 id='competence_title'>Compétences</h2>
        </div>
        <img src='./Image/Pellicule_Fixe_Contact_Gris_et_Logo.png' alt='Pellicule contact' className='pellicule_contact' />
        <div id='lien_made_in_paese'>
          <a href='https://www.madeinpaese.corsica/'>
            <img src='./Image/Made_in_Paese.png' alt='Made in Paese lien' className='lien_pic' />
          </a>
        </div>
        <div id='lien_insta'>
          <a href='https://www.instagram.com/skypini20/'>
            <img src='./Image/Instagram.png' alt='Instagram lien' className='lien_pic' />
          </a>
        </div>
        <div id='lien_linkedin'>
          <a href='https://www.linkedin.com/in/pierre-nicolas-michelozzi-42948a334/'>
            <img src='./Image/Linkedin.png' alt='Linkedin lien' className='lien_pic' />
          </a>
        </div>
        <div id='lien_yt'>
          <a href='https://youtube.com/@pierre-nicolasmichelozzi4203?si=t2OE_-2cyau1bcqM'>
            <img src='./Image/YouTube.png' alt='Youtube lien' className='lien_pic' />
          </a>
        </div>
        <h2 id='contact'>Me contacter</h2>
        <div id='traditional_contact'>
          <p>Tel: </p>
          <p id='contact_tel'>07 82 87 41 50</p>
          <p>Mail: </p>
          <p>pierrenicolas.michelozzi@gmail.com</p>
        </div>
      </div>
    </div >
  );
}

export default App;
